import React, { Component } from 'react';
import { api } from '../../config/Services';
import { DetailRequest } from '../../utilities/services/RequestService';
import { Skeleton } from 'antd';
import { Layout, Row, Col, Icon } from 'antd';

const { Content } = Layout;

class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            formrender: true,
            loading: true,
            showModal: false,
            isLoading: true,
            profile: {},
            memberidentity: '-',
            mileageExpiryModal: {
                isLoading: false,
                visible: false
            },
            dimensions: {
                height: window.innerHeight,
                width: window.innerWidth
            }
        };
    };

    componentDidMount() { };

    retrieveData = (memberid) => {
        let url = api.url.member.list;
        let data = { memberid };
        this.setState({ isLoading: true });

        DetailRequest(url, data).then((response) => {
            const { status, result } = response;
            if (status.responsecode === '0000' && result) {
                const { nameoncard } = result || {};
                const profile = {
                    nameoncard,
                    memberid: result.memberid,
                    cardnumber: (result.membercards !== null && result.membercards !== undefined && result.membercards[0] !== undefined && result.membercards[0].cardnumber !== undefined) ? result.membercards[0].cardnumber : '-',
                };

                this.setState({ profile })
            }
            this.setState({ isLoading: false });
        });
    };


    render() {
        const { isLoading } = this.state;

        if (isLoading) {
            return (
                <Layout className='header-layout'>
                    <Skeleton active />
                </Layout>
            )
        } else {
            const { profile } = this.state;
            const { nameoncard, cardnumber } = profile || {};

            return (
                <Layout style={{ background: '#fff' }} >
                    <Content style={{ alignContent: 'center', margin: '10px', padding: '10px 0px 10px 10px', background: '#deefff', borderRadius: '8px', boxShadow: '0 1px 15px 1px rgba(69,65,78,.1)' }}>
                        <Row gutter={8} style={{ marginTop: '6px', width: '100%', alignContent: "center" }}>
                            <Col xs={24}>
                                <Row className="member-profile">
                                    <Col xs={24} style={{ marginTop: '10px', marginBottom: '2vh', textAlign: 'center', textTransform: 'uppercase' }}>
                                        <img src={'https://amala-pdt.garuda-indonesia.com/uploads/filetransfer/garuda-indonesia-garudamiles-logo.png'} alt="garuda-miles-image" width="130" style={{ marginBottom: 10, borderRadius: 8 }} />
                                        <p style={{ alignContent: 'center', textTransform: 'uppercase', fontSize: '16px', color: '#1a1a1a', fontWeight: '700' }}>{nameoncard}</p>
                                        <p>CARD NUMBER</p>
                                        <span><Icon type="credit-card" /> {cardnumber}</span>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Content>
                </Layout>
            )
        }
    }
}
export default App;
